export default {
  aiApi: {
    getChartAIMessages: 'api/IMAIServer/getChartAIMessages',
    sendAIMessage: 'api/IMAIServer/sendAIMessage',
    getChartAIStatus: 'api/IMAIServer/getChartAIStatus',
    clearAIToken: 'api/IMAIServer/clearAIToken',
    getAIBaseConfig: 'api/IMAIServer/getAIBaseConfig',
    updateAIBASEConfig: 'api/IMAIServer/updateAIBASEConfig',
    configQF: {
      getAIConfig: 'api/IMAIQFServer/getAIConfig',
      updateAIConfig: 'api/IMAIQFServer/updateAIConfig',
      getPromptList: 'api/IMAIQFServer/getPromptList',
      delPrompt: 'api/IMAIQFServer/delPrompt',
      saveOrUpdatePrompt: 'api/IMAIQFServer/saveOrUpdatePrompt',
      getPromptOptions: 'api/IMAIQFServer/getPromptOptions',
      getServiceOptions: 'api/IMAIQFServer/getServiceOptions',
    },
    configBST: {
      getAIConfig: 'api/IMAIBSTServer/getAIConfig',
      updateAIConfig: 'api/IMAIBSTServer/updateAIConfig',
      getServiceOptions: 'api/IMAIBSTServer/getServiceOptions'
    },
    aiStatistics: {
      totalData: 'api/aiStatistics/totalData',
      exportData: 'api/aiStatistics/exportData',
    },
    aiTools: {
      applications: '/api/aiTools/applications',
      getLimitTypes: '/api/aiTools/getLimitTypes',
      saveOrUpdateApplication: '/api/aiTools/saveOrUpdateApplication',
      delApplications: '/api/aiTools/saveOrUpdateApplication',
      getAIAccessLogs: '/api/aiTools/getAIAccessLogs',
      getAIModelTypes: '/api/aiTools/getAIModelTypes',
      getAIModelOptions: '/api/aiTools/getAIModelOptions',
      getPromptList: '/api/aiTools/getPromptList',
      delPrompt: '/api/aiTools/delPrompt',
      saveOrUpdatePrompt: '/api/aiTools/saveOrUpdatePrompt',
      getAIToolsOptions: '/api/aiTools/getAIToolsOptions',
      changeStatus: '/api/aiTools/changeStatus',
      getModelConfigList: '/api/aiTools/getModelConfigList',
      saveOrUpdateConfig: '/api/aiTools/saveOrUpdateConfig',
      delConfig: '/api/aiTools/delConfig',
      getToolUseLogs: '/api/aiToolCommon/getToolUseLogs',
      sendAIMessage: '/api/aiToolCommon/sendAIMessage',
      correctMessage: '/api/aiToolCommon/correctMessage',
      getAIToolStatus: '/api/aiToolCommon/getAIToolStatus',
      getAIToolPrompt: '/api/aiToolCommon/getAIToolPrompt'
    }
  }
}
